import { render, staticRenderFns } from "./NewVersionModal.vue?vue&type=template&id=9be69d98&scoped=true"
import script from "./NewVersionModal.vue?vue&type=script&lang=js"
export * from "./NewVersionModal.vue?vue&type=script&lang=js"
import style0 from "./NewVersionModal.vue?vue&type=style&index=0&id=9be69d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be69d98",
  null
  
)

export default component.exports